import styles from './ThreeItemScatter.module.css';
import CMSLink from './common/CMSLink.jsx';
import Arrow from '../assets/arrowTopRight.jsx';
import { useEffect, useState } from 'react';
import { useSmoother } from './common/SmootherContext.js';
import { useWindowSize } from '../utilities/useWindowSize.js';

function ThreeItemScatter({
    title,
    studioTitle,
    studioColor,
    studioVideo,
    studioCaption,
    studioLink,
    studioCtaText,
    studioCtaColor,
    studioCtaBackground,
    vfxTitle,
    vfxColor,
    vfxVideo,
    vfxCaption,
    vfxLink,
    vfxCtaText,
    vfxCtaColor,
    vfxCtaBackground,
    labsTitle,
    labsColor,
    labsVideo,
    labsCaption,
    labsLink,
    labsCtaText,
    labsCtaColor,
    labsCtaBackground
}) {

    const smoother = useSmoother()

    const { width, height } = useWindowSize();

    // adding support for image and videos, need to detect media type
    const getMediaType = (url) => {
        if (!url) return null;
        const extension = url.split('.').pop().toLowerCase();
        const videoExtensions = ['mp4', 'webm', 'ogg', 'mov'];
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp'];

        if (videoExtensions.includes(extension)) return 'video';
        if (imageExtensions.includes(extension)) return 'image';
        return null;
    };

    const studioMediaType = getMediaType(studioVideo);
    const vfxMediaType = getMediaType(vfxVideo);
    const labsMediaType = getMediaType(labsVideo);

    useEffect(() => {
        // Only apply effect if not on mobile
        const isMobile = window.matchMedia('(max-width: 915px)').matches;

        if (!isMobile) {
            const timeout = setTimeout(() => {
                if (smoother) {
                    smoother.effects("[data-speed]"); // reapply scroll effects
                    smoother.refresh(); // re-calculate layout
                }
            }, 300); // slight delay helps ensure DOM is fully updated

            return () => clearTimeout(timeout);
        }
    }, [smoother]);

    return (
        <section className={styles.threeItemScatter}>

            <div className={styles.grid}>
                <div className={`cell ${styles.item}`}>
                    <div className={styles.title}>{title}</div>

                    <CMSLink path={studioLink}>

                        <div className={styles.videoWrap} >
                            {studioMediaType === "video" && (
                                <video muted autoPlay loop playsInline>
                                    <source src={studioVideo} type="video/mp4" />
                                </video>
                            )}
                            {studioMediaType === "image" && (
                                <img
                                    className={styles.image}
                                    src={studioVideo}
                                    alt={studioTitle}
                                />
                            )}
                            <div className={styles.pixel} style={{ backgroundColor: studioColor }}></div>
                            <div className={`ctaBox ${styles.cta}`} style={{ color: studioCtaColor, backgroundColor: studioCtaBackground, '--hoverColor': studioColor }}>
                                <div className="contents">
                                    {studioCtaText}
                                    <Arrow />
                                </div>
                            </div>
                        </div>

                        <div className={styles.text}>
                            <h2 style={{ color: studioColor }}>{studioTitle}</h2><p>{studioCaption}</p>
                        </div>

                    </CMSLink>
                </div>
                <div className={`cell ${styles.item}`} data-speed={width > 767 ? ".9" : "1"}>

                    <CMSLink path={vfxLink}>
                        <div className={styles.videoWrap}>
                            {vfxMediaType === "video" && (
                                <video muted autoPlay loop playsInline>
                                    <source src={vfxVideo} type="video/mp4" />
                                </video>
                            )}
                            {vfxMediaType === "image" && (
                                <img
                                    className={styles.image}
                                    src={vfxVideo}
                                    alt={vfxTitle}
                                />
                            )}
                            <div className={styles.pixel} style={{ backgroundColor: vfxColor }}></div>
                            <div className={`ctaBox ${styles.cta}`} style={{ color: vfxCtaColor, backgroundColor: vfxCtaBackground, '--hoverColor': vfxColor }}>
                                <div className="contents">
                                    {vfxCtaText}
                                    <Arrow />
                                </div>
                            </div>
                        </div>

                        <div className={styles.text}>
                            <h2 style={{ color: vfxColor }}>{vfxTitle}</h2><p>{vfxCaption}</p>
                        </div>
                    </CMSLink>
                </div>
                <div className={`cell ${styles.item}`}>
                    <CMSLink path={labsLink}>
                        <div className={styles.videoWrap}>
                            {labsMediaType === "video" && (
                                <video muted autoPlay loop playsInline>
                                    <source src={labsVideo} type="video/mp4" />
                                </video>
                            )}
                            {labsMediaType === "image" && (
                                <img
                                    className={styles.image}
                                    src={labsVideo}
                                    alt={labsTitle}
                                />
                            )}
                            <div className={styles.pixel} style={{ backgroundColor: labsColor }}></div>
                            <div className={`ctaBox ${styles.cta}`} style={{ color: labsCtaColor, backgroundColor: labsCtaBackground, '--hoverColor': labsColor }}>
                                <div className="contents">
                                    {labsCtaText}
                                    <Arrow />
                                </div>
                            </div>
                        </div>

                        <div className={styles.text}>
                            <h2 style={{ color: labsColor }}>{labsTitle}</h2><p>{labsCaption}</p>
                        </div>

                    </CMSLink>
                </div>
            </div>
        </section>



    );
}

export default ThreeItemScatter;